import React from 'react'
import { css } from '@linaria/core'

import { AdobeTargetProvider } from '@fs/zion-adobe-target'
import { FeatureFlagsProvider } from '@fs/zion-flags'
import { NoticeLoading } from '@fs/zion-icon'

const center = css`
  position: fixed;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
`

function LoadingSpinner() {
  return (
    <div role="alert" data-testid="flagLoadingSpinner" aria-busy="true" className={center}>
      <NoticeLoading size="lg" />
    </div>
  )
}

export default function FrontierBaseProviders({ flagOptions, mockFlags, mockActivities, children }) {
  return (
    <FeatureFlagsProvider {...flagOptions} mockFlags={mockFlags} LoadingFallback={LoadingSpinner}>
      <AdobeTargetProvider mockActivities={mockActivities}>{children}</AdobeTargetProvider>
    </FeatureFlagsProvider>
  )
}
